import { render, staticRenderFns } from "./HumanCancerModelPage.vue?vue&type=template&id=17b452f8&scoped=true"
var script = {}
import style0 from "./HumanCancerModelPage.vue?vue&type=style&index=0&id=17b452f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b452f8",
  null
  
)

export default component.exports